/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 다이얼로그 모달창
 * 버전 : 1.0
 * 파일명 : CommonModals.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-12-18
 * ================================================================ 
 * 수정일 : 2025-12-29, 강동형, 두개 버튼 Footer가 스타일을 받도록 변경
 * ================================================================ */

import React, { useState } from "react"
import { useMainPageDialogStore } from "src/stores/DialogStore"

type Dialog_ModalContent_TextAreaProp = {
    textArea: string,
}

export const Dialog_ModalContent_TextArea = ({textArea}:Dialog_ModalContent_TextAreaProp)=>{
    const [textAreaState,setTextAreaState] = useState(textArea)
    const setField = useMainPageDialogStore(s=>s.setField)

    const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const v = e.target.value;
        setTextAreaState(v);
        setField("tempTextArea", v); // ✅ 즉시 반영
    };

    return(
        <textarea value={textAreaState} onChange={onChange} style={{marginBottom:'16px',height:'130px'}}/>
    )
}